(function () {
  if (window.__fhNotifyMeLoaded) return;
  window.__fhNotifyMeLoaded = true;

  var WORKER_URL = 'https://fh-restock-alerts.jekaaca.workers.dev/subscribe';

  function submitNotify(container) {
    var emailInput = container.querySelector('[data-fh-notify-email]');
    var messageEl = container.querySelector('[data-fh-notify-message]');
    var submitBtn = container.querySelector('[data-fh-notify-submit]');
    var email = (emailInput.value || '').trim();

    if (!email) {
      emailInput.reportValidity && emailInput.reportValidity();
      return;
    }

    submitBtn.disabled = true;
    var originalText = submitBtn.textContent;
    submitBtn.textContent = 'Šaljem...';

    var payload = {
      email: email,
      variantId: container.querySelector('[data-fh-notify-variant-id]').value,
      productTitle: container.querySelector('[data-fh-notify-product-title]').value,
      productUrl: container.querySelector('[data-fh-notify-product-url]').value,
      productImage: container.querySelector('[data-fh-notify-product-image]').value,
    };

    fetch(WORKER_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
      .then(function (res) {
        return res
          .json()
          .catch(function () { return {}; })
          .then(function (data) { return { ok: res.ok, data: data }; });
      })
      .then(function (result) {
        if (result.ok && result.data && result.data.ok) {
          messageEl.textContent = 'Javićemo ti mejlom čim bude ponovo dostupno.';
          messageEl.hidden = false;
          messageEl.classList.remove('fh-notify-me__message--error');
          messageEl.classList.add('fh-notify-me__message--success');
          emailInput.value = '';
          submitBtn.textContent = 'Prijavljeno ✓';
        } else {
          messageEl.textContent = 'Greška — pokušaj ponovo.';
          messageEl.hidden = false;
          messageEl.classList.add('fh-notify-me__message--error');
          submitBtn.disabled = false;
          submitBtn.textContent = originalText;
        }
      })
      .catch(function () {
        messageEl.textContent = 'Greška — proveri konekciju i pokušaj ponovo.';
        messageEl.hidden = false;
        messageEl.classList.add('fh-notify-me__message--error');
        submitBtn.disabled = false;
        submitBtn.textContent = originalText;
      });
  }

  function initNotifyForm(container) {
    if (container.dataset.fhNotifyBound) return;
    container.dataset.fhNotifyBound = 'true';

    var submitBtn = container.querySelector('[data-fh-notify-submit]');
    var emailInput = container.querySelector('[data-fh-notify-email]');

    submitBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      submitNotify(container);
    });

    emailInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        e.stopPropagation();
        submitNotify(container);
      }
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-fh-notify-form]').forEach(initNotifyForm);
  }

  document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  initAll(document);

  document.addEventListener('shopify:section:load', function () { initAll(document); });

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('[data-fh-notify-form]')) initNotifyForm(node);
        if (node.querySelectorAll) initAll(node);
      });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
